import WrapDatabase from './WrapDatabase';
export default WrapDatabase;